import { render, staticRenderFns } from "./tipIcon.vue?vue&type=template&id=4965b386&"
import script from "./tipIcon.vue?vue&type=script&lang=js&"
export * from "./tipIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4965b386')) {
      api.createRecord('4965b386', component.options)
    } else {
      api.reload('4965b386', component.options)
    }
    module.hot.accept("./tipIcon.vue?vue&type=template&id=4965b386&", function () {
      api.rerender('4965b386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/tipIcon.vue"
export default component.exports